<template>
  <div class="am-telephony">
    <span class="problue">
      <strong>Telephony: </strong>
    </span>
    <span>|</span>
    <a v-if="$store.state.auth.telephony.telephonyActive" @click="telephonyTurnOff()">Turn Off</a>
    <a v-if="!$store.state.auth.telephony.telephonyActive" @click="telephonyTurnOn()">Turn On</a>
    <span>|</span>
    <a>AM-VBX</a>
  </div>
</template>

<script>
import api from './../http'
import config from './../config/global.config'

export default {
  name: 'Telephony',

  methods: {
    telephonyTurnOn () {
      api.post(config.applicationUrl('telephonyTurnOnOff.php?OnOff=ON'))
      window.open(config.applicationUrl('telephonyBrowser.php'), 'AgencyMatrixTelephony', 'width=700,height=500')
      this.toggleTelephony()
    },

    telephonyTurnOff () {
      api.post(config.applicationUrl('telephonyTurnOnOff.php?OnOff=ON'))
      var openWindow = window.open('', 'AgencyMatrixTelephony')
      openWindow.close()
      this.toggleTelephony()
    },

    toggleTelephony () {
      this.$store.state.auth.telephony.telephonyActive = !this.$store.state.auth.telephony.telephonyActive
    }
  }
}
</script>

<style scoped>
    .am-telephony a {
      color: #044e99;
      cursor: pointer;
    }
</style>
